import axios from "axios";

const PaymentProviderApi = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL || "https://payment-api.healthblocks.ai",
});

PaymentProviderApi.interceptors.response.use(
    (response) => {
      console.log(response.data)
      // Transform data here if needed
      return response;
    },
    async (error) => {
      // Do something with response error
      return Promise.reject(error);
    }
  );

  PaymentProviderApi.interceptors.request.use(
    async (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

export default PaymentProviderApi;